module.exports = __webpack_public_path__ + "static/media/basket-icon.8c9b826f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/basket-icon.svg
// module id = 774
// module chunks = 0